export default __webpack_public_path__ + "static/transparent-7b7756f11838d529ca3deed262ec8b08.png";